import { lazy } from 'react';

// project imports
import AuthGuard from 'components/auth/AuthGuard';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const ProfilePage = Loadable(lazy(() => import('pages/profile')));
const IntegrationsPage = Loadable(lazy(() => import('pages/integrations')));
const PricingPage = Loadable(lazy(() => import('pages/pricing')));
const ProgramWorkPage = Loadable(lazy(() => import('pages/program-work')));
const PoliciesPage = Loadable(lazy(() => import('pages/policies')));
const AccessReviewsPage = Loadable(lazy(() => import('pages/access-reviews')));
const AuditPacketPage = Loadable(lazy(() => import('pages/audit-packet')));
const EvidencePage = Loadable(lazy(() => import('pages/evidence')));
const ControlsPage = Loadable(lazy(() => import('pages/controls')));
const RisksPage = Loadable(lazy(() => import('pages/risks')));
const ControlDetailPage = Loadable(lazy(() => import('pages/controls/detail')));
const ControlEvidenceUploadPage = Loadable(lazy(() => import('pages/controls/upload-evidence')));
const ResponsesPage = Loadable(lazy(() => import('pages/responses')));
const SecurityReviewsPage = Loadable(lazy(() => import('pages/security-reviews')));
const RemediationPage = Loadable(lazy(() => import('pages/remediation')));
const TeamPage = Loadable(lazy(() => import('pages/team')));
const ActivityPage = Loadable(lazy(() => import('pages/activity')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'overview',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'integrations',
      element: <IntegrationsPage />
    },
    {
      path: 'pricing',
      element: <PricingPage />
    },
    {
      path: 'program-work',
      element: <ProgramWorkPage />
    },
    {
      path: 'policies',
      element: <PoliciesPage />
    },
    {
      path: 'access-reviews',
      element: <AccessReviewsPage />
    },
    {
      path: 'audit-packet',
      element: <AuditPacketPage />
    },
    {
      path: 'evidence',
      element: <EvidencePage />
    },
    {
      path: 'risks',
      element: <RisksPage />
    },
    {
      path: 'controls',
      element: <ControlsPage />
    },
    {
      path: 'controls/:organizationControlsId',
      element: <ControlDetailPage />
    },
    {
      path: 'controls/:organizationControlsId/evidence/new',
      element: <ControlEvidenceUploadPage />
    },
    {
      path: 'responses',
      element: <ResponsesPage />
    },
    {
      path: 'security-reviews',
      element: <SecurityReviewsPage />
    },
    {
      path: 'remediation',
      element: <RemediationPage />
    },
    {
      path: 'tasks',
      element: <RemediationPage />
    },
    {
      path: 'team',
      element: <TeamPage />
    },
    {
      path: 'activity',
      element: <ActivityPage />
    },
    {
      path: 'profile',
      element: <ProfilePage />
    }
  ]
};

export default MainRoutes;
